export default __webpack_public_path__ + "static/media/Social 04.853bbfbe.png";